import React from 'react';
import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/35133248/pexels-photo-35133248.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
          alt="Obrador Pomodoro Interior"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1
            className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 animate-fade-in"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Obrador Pomodoro
          </h1>
          <p className="text-xl sm:text-2xl text-white/90 mb-8 font-light tracking-wide">
            Una experiencia italiana en Rosario
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              asChild
              className="bg-[#C1272D] hover:bg-[#A01F25] text-white px-8 py-6 text-lg transition-all hover:scale-105"
            >
              <a
                href="https://pedir.tucan.la/menu/PomodoroPastas/Sal%C3%B3n"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ver Carta
              </a>
            </Button>
            <Button
              onClick={() => scrollToSection('contact')}
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-[#C1272D] px-8 py-6 text-lg transition-all hover:scale-105"
            >
              Reservar Mesa
            </Button>
            <Button
              asChild
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-[#C1272D] px-8 py-6 text-lg transition-all hover:scale-105"
            >
              <a
                href="https://www.google.com/maps/search/?api=1&query=Obrador+Pomodoro+Rosario"
                target="_blank"
                rel="noopener noreferrer"
              >
                Cómo llegar
              </a>
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <ChevronDown className="text-white" size={40} />
      </div>
    </section>
  );
};

export default Hero;
